import { createRoot } from "react-dom/client";
import Providers from "./providers";
import Router from "./routes/Router";
import "./global.css";

const container = document.getElementById("root") as HTMLDivElement;
if (!container) throw new Error("Root container not found");

const root = createRoot(container);

root.render(
  <Providers>
    <Router />
  </Providers>
);

